// extracted by mini-css-extract-plugin
export default {"form":"Survey_form__KkK5u","general":"Survey_general__SGprv","invalid":"Survey_invalid__hFtl6"};